import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import Radio from '../../../buttons/Radio';
import { toBoolean } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function RadioYesNo(props) {
  const value = toBoolean(props.value);
  return /*#__PURE__*/_jsxs("div", {
    className: "d-flex flex-row justify-content-start align-items-center",
    children: [props.title, /*#__PURE__*/_jsx(Radio, {
      name: `radio-${props.id}-yes`,
      "data-id": `radio-${props.id}-yes`,
      checked: value,
      value: true,
      onChange: props.onChange,
      label: I18n.t('action.yes')
    }), /*#__PURE__*/_jsx(Radio, {
      name: `radio-${props.id}-no`,
      "data-id": `radio-${props.id}-no`,
      checked: value === false,
      value: false,
      onChange: props.onChange,
      label: I18n.t('action.no')
    })]
  });
}
RadioYesNo.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number])
};
export default RadioYesNo;